<template>
	<sf-content-layout>
		<template v-slot:title>
			<sf-content-title :title="title" />
		</template>
		<template v-slot:content>
			<sf-sitemap :menu="menu" @menuClick="menuClick" />
		</template>
	</sf-content-layout>
</template>

<script>
//Local 사이트맵 화면 Component
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	data() {
		return {
			menu: [] //사이트맵에 보여줄 local 메뉴: 기본 값
		};
	},

	mounted() {
		//route name이 testScreen(tab이 아닌 routing 형식), test(tab  메뉴 형식) 둘 중 어떤 형태로 와도 Store에서 test로 메뉴 검색
		const name = this.$route.name.split('Screen')[0];
		this.menu = this.calculateMenu(this.getMenu_({ name }).menuItemList); //사이트맵에 보여줄 메뉴 설정: store에 있는 가공한 메뉴 리스트
	},

	computed: {
		...rootComputed,

		isOnsite() {
			return process.env.VUE_APP_ONSITE_PROJECT === 'true';
		},

		menuData() {
			const name = this.$route.name.split('Screen')[0];
			return this.getMenu_({ name });
		},

		//화면 타이틀
		title() {
			return this.getMessage_('SWCC000461'); //다국어: 사이트맵
		}
	},

	watch: {
		//store의 다국어 Map이 변경이 감지되면 사이트맵에 넣어주는 menu 변경(다국어 적용을 위함)
		userMessage() {
			this.menu = this.calculateMenu(this.menuData.menuItemList); //localMenu 변경
		}
	},

	methods: {
		...rootMethods,

		//사이트맵에서 메뉴 클릭시
		async menuClick({ item }) {
			//onsite일 때 화면 정보 조회
			if (this.isOnsite) {
				await this.getScreen_({ scrId: item.scrId })
					.then(header => {
						if (header.code !== 0) {
							this.$sf_toast({
								...this.$sf_setToastOption(header),
								message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
							});
						}
					})
					.catch(error => {
						this.$sf_toast({ title: 'Error', type: 'error', message: error.message });
					});
			}

			if (this.menuData.useTabMenuYN === 'Y') {
				const postParam = item.direct ? { message: 'sendUser', ...this.getUser_ } : null; //direct 이동 화면이라면 post로 보낼 데이터 셋팅
				this.$sf_addTab(item, item.scrId, { scrId: item.scrId }, postParam); //화면 탭 추가
			} else {
				this.$router.push(`${this.menuData.scrUrl}/${item.scrId}`).catch(() => {}); //클릭한 메뉴를 라우팅하기 위한 URL로 이동
			}
		},

		//메뉴 리스트를 가공하기 위한 재귀 함수
		calculateMenu(menus) {
			return menus.map(menu => {
				let temp = { ...menu };
				temp.name = this.getMessage_(menu.msgKey); //다국어를 적용한 메뉴 명으로 등록
				if (temp.items) {
					temp.items = this.calculateMenu(temp.items);
				}
				return temp;
			});
		}
	}
};
</script>

<style></style>
